import Grid from "@mui/material/Grid";
import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import { formatAwsDateString } from "@covertree/utils";

import { PolicyDetailsContentProps } from "../../../types";

export function CancellationDetails({ policy }: PolicyDetailsContentProps) {
  return (
    <Grid item xs={12}>
      <DisplayPropertiesCard
        properties={[
          {
            label: "Cancellation created date",
            value: formatAwsDateString(policy!.cancellationCreatedDate!),
            gridSize: 6,
          },
          {
            label: "Cancellation effective date",
            value: formatAwsDateString(policy!.cancellationEffectiveDate!),
            gridSize: 6,
          },
        ]}
      />
    </Grid>
  );
}
